import { BaseCommand } from "./baseCommand";
import { AbstractConfDataCommand } from "./abstractConfDataCommand";

export class AritcoCopyCommand extends AbstractConfDataCommand {
  confs: string[];
}